import { Record } from 'immutable';
import { stateFactory as entireVideoStateFactory } from '../../factories/entire-video';
import { VideoUploadState } from './types';

export const stateFactory = Record<VideoUploadState>({
  isUploading: false,
  uploadProgress: undefined,
  videoUploadOptions: undefined,
  multipartAbortOptions: undefined,
  uploadIdentifier: undefined,
  uploadedVideoId: undefined,
  entireVideo: entireVideoStateFactory(),
});
